import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDrumOrCondenser = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 91.54,
	height: 30,
	viewBox: "0 0 91.54 30.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 5.77 30.0 L 85.77 30.0 A 5.0 13.0 0.0 0 0 85.77 0.0 L 5.77 0.0 A 5.0 13.0 0.0 0 0 5.77 30.0 Z M 5.77 0.0 L 5.77 30.0 M 85.77 0.0 L 85.77 30.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgDrumOrCondenser;
